// extracted by mini-css-extract-plugin
export default {"container":"ZN-z","dimension":"_N-z","dimensionLabels":"aO-z"};